import { MedicalAppointmentConfirmation } from "../../../model/medical-appointment-cancel";
import { ReservationService } from "../../../services/reservation.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { Inject, OnInit, Component } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";



export class MedicalAppointmenConfirmationDialogRequest {
  public medicalAppointmentIds: number[];
  public confirmationStatusId?: number;
}


@Component({
  selector: 'app-medical-appointment-confirmation-dialog',
  templateUrl: 'medical-appointment-confirmation-dialog.component.html',
  styleUrls: ['./medical-appointment-confirmation-dialog.component.css']
})
export class MedicalAppointmenConfirmationDialogComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  form: FormGroup;
  medicalAppointmentConfirmations: MedicalAppointmentConfirmation[] = [];

  constructor(private reservationService: ReservationService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<MedicalAppointmenConfirmationDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: MedicalAppointmenConfirmationDialogRequest) {

      this.form = this.formBuilder.group({
       Observation: ['']
      });
  }

  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      this.loadingAction = true;

      await this.reservationService.MedicalAppointmentConfirmationUpdate(
        this.data.medicalAppointmentIds ,
        this.data.confirmationStatusId ,
        this.form.controls.Observation.value);

      this.dialogRef.close(true);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Turno confirmación');
    } finally {
      this.loadingAction = false;
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      if (this.data.medicalAppointmentIds.length == 1) {
        this.medicalAppointmentConfirmations =
          await this.reservationService.getMedicalAppointmentConfirmations(this.data.medicalAppointmentIds[0]);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Confirmación de turnos');
    } finally {
      this.loading = false;
    }
  }
}
